import React from "react";
import { ControlPointCard } from "../BisControlCards";
import { hasText } from "../bisDossierData";
import { sectionTitleMarkerStyle, sectionTitleStyle } from "../bisLayoutStyles";
import { PATIENT_CONTROL_POINTS, VARIANT } from "../bisVariant";
import { renderControlPointAction } from "./ControlPointActionView";
import { renderInlinePatientControl } from "./InlinePatientControlView";
import { renderSpecialControlSection } from "./SpecialControlSectionView";
import { controlPointColor, controlPointLabel, controlPointNumber } from "../../shared/controleVariants";
import { isControlePatientActive, normalizePatientPointState } from "../../shared/patientControlRules";

export function renderControlSection(view, section, sectionIndex) {
    const { activeControleMode, activeControlePatientCount, controle, preProductionLocked, workspace } = view;
    const sectionLocked = preProductionLocked && section.key === "avantLancement";
    const specialContent = renderSpecialControlSection(view, section.key);
    return (
    <section key={section.key} style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <div style={sectionTitleStyle}>
            <span style={sectionTitleMarkerStyle} />
            <span>{section.title}</span>
        </div>
        {specialContent ?? section.rows.map(([rowKey, label], rowIndex) => {
            const displayLabel = controlPointLabel(VARIANT, section.key, rowKey, label, activeControleMode);
            const pointNumber = controlPointNumber(VARIANT, sectionIndex, rowIndex);
            const pointColor = controlPointColor(pointNumber);
            const patientControlPointComplete = PATIENT_CONTROL_POINTS.some(([pointKey]) => pointKey === rowKey)
                && activeControlePatientCount > 0
                && controle.patients
                    .filter(isControlePatientActive)
                    .every(patient => normalizePatientPointState((workspace.formData.controlePatients || {})[patient.patientId]?.[rowKey]).validated);
            const pointComplete = patientControlPointComplete
                || (rowKey === "importEureka" && Boolean(workspace.formData.commentaires?.importEurekaValidation?.validatedAt))
                || (rowKey === "besoinsRemplissage" && (hasText(workspace.formData.commentaires?.besoinsRemplissageCassette) || (workspace.formData.piecesJointes || []).some(attachment => attachment.section === "preprodPoint6")))
                || hasText({
                    fspMduHp: workspace.formData.commentaires?.fspMduHpEureka,
                    rappelsProduction: workspace.formData.commentaires?.validationRetraitsPreProduction,
                    ruptures: workspace.formData.commentaires?.rupturesMedicament,
                    sortiesCassettes: workspace.formData.commentaires?.sortiesMedicamentsArretesRompus,
                    retraitsLots: workspace.formData.commentaires?.validationRetraitsLots,
                }[rowKey]);
            return (
                <React.Fragment key={rowKey}>
                    <ControlPointCard
                        number={pointNumber}
                        color={pointColor}
                        label={displayLabel}
                        complete={pointComplete}
                        action={renderControlPointAction(view, rowKey, pointColor, sectionLocked)}
                    />
                    {section.key === "avantLancement" && rowKey === "importEureka" && renderInlinePatientControl(view)}
                </React.Fragment>
            );
        })}
    </section>
    );
}
